export const buildNum = '12065';
export const buildEnvironment = 'production';
